// @ts-ignore
import * as Vue from 'vue';
var allVue = Vue;
var gh = allVue.h;
var isV3 = allVue.version && allVue.version[0] === '3';
var ref = allVue.ref;
import { BaseChart } from './BaseChart';
import { DonutCenter } from './DonutCenter';
import { Chart as KendoChart } from '@progress/kendo-charts';
import { classNames, getDefaultSlots, getListeners, getRef, setRef, templateRendering } from '@progress/kendo-vue-common';
/**
 * @hidden
 */

var ChartVue2 = {
  name: 'KendoChart',
  props: {
    donutCenterRender: [String, Function, Object],
    dir: String,
    renderAs: {
      type: String,
      default: undefined,
      validator: function validator(value) {
        return ['svg', 'canvas'].includes(value);
      }
    },
    pannable: {
      type: [Boolean, Object],
      default: function _default() {
        return undefined;
      }
    },
    zoomable: {
      type: [Boolean, Object],
      default: function _default() {
        return undefined;
      }
    },
    seriesColors: {
      type: Array,
      default: function _default() {
        return undefined;
      }
    },
    transitions: {
      type: Boolean,
      default: true
    },
    paneDefaults: {
      type: Object,
      default: function _default() {
        return undefined;
      }
    },
    panes: {
      type: Array,
      default: function _default() {
        return undefined;
      }
    },
    seriesDefaults: {
      type: Object,
      default: function _default() {
        return undefined;
      }
    },
    axisDefaults: {
      type: Object,
      default: function _default() {
        return undefined;
      }
    }
  },
  updated: function updated() {
    this.baseChart = getRef(this, 'baseChart');
  },
  mounted: function mounted() {
    this.baseChart = getRef(this, 'baseChart');
  },
  methods: {
    chartInstance: function chartInstance() {
      if (this.baseChart !== null) {
        return this.baseChart.chartInstance;
      }

      return null;
    },
    surface: function surface() {
      if (this.baseChart !== null) {
        return this.baseChart.surface;
      }

      return null;
    },
    element: function element() {
      if (this.baseChart !== null) {
        return this.baseChart.element;
      }

      return null;
    },
    getTarget: function getTarget() {
      return this;
    },
    handleBaseChartEvents: function handleBaseChartEvents(name, options) {
      this.$emit(name, options);
    }
  },
  // @ts-ignore
  setup: !isV3 ? undefined : function () {
    var v3 = !!isV3;
    return {
      v3: v3
    };
  },
  render: function render(createElement) {
    var _this = this;

    var h = gh || createElement;
    var defaultSlots = getDefaultSlots(this);
    var _a = this.$props,
        donutCenterRender = _a.donutCenterRender,
        dir = _a.dir,
        renderAs = _a.renderAs,
        pannable = _a.pannable,
        zoomable = _a.zoomable,
        seriesColors = _a.seriesColors,
        transitions = _a.transitions,
        paneDefaults = _a.paneDefaults,
        panes = _a.panes,
        seriesDefaults = _a.seriesDefaults,
        axisDefaults = _a.axisDefaults;
    var centerRender = donutCenterRender ? templateRendering.call(this, donutCenterRender, getListeners.call(this)) : null;
    return (// @ts-ignore  function children
      h(BaseChart, {
        dir: dir,
        attrs: this.v3 ? undefined : {
          dir: dir,
          renderAs: renderAs,
          pannable: pannable,
          zoomable: zoomable,
          seriesColors: seriesColors,
          transitions: transitions,
          paneDefaults: paneDefaults,
          panes: panes,
          seriesDefaults: seriesDefaults,
          axisDefaults: axisDefaults,
          chartConstructor: KendoChart,
          getTarget: this.getTarget,
          wrapper: "div",
          allListeners: getListeners.call(this)
        },
        renderAs: renderAs,
        pannable: pannable,
        zoomable: zoomable,
        seriesColors: seriesColors,
        transitions: transitions,
        paneDefaults: paneDefaults,
        panes: panes,
        seriesDefaults: seriesDefaults,
        axisDefaults: axisDefaults,
        ref: setRef(this, 'baseChart'),
        chartConstructor: KendoChart,
        getTarget: this.getTarget,
        wrapper: "div",
        "class": classNames('k-chart k-widget'),
        onBasechartevent: this.handleBaseChartEvents,
        on: this.v3 ? undefined : {
          "basechartevent": this.handleBaseChartEvents
        },
        allListeners: getListeners.call(this)
      }, this.v3 ? function () {
        return [defaultSlots, // @ts-ignore
        h(DonutCenter, {
          render: centerRender,
          attrs: _this.v3 ? undefined : {
            render: centerRender
          }
        })];
      } : [defaultSlots, h(DonutCenter, {
        render: centerRender,
        attrs: _this.v3 ? undefined : {
          render: centerRender
        }
      })])
    );
  }
};
/**
 * @hidden
 */

var Chart = ChartVue2;
export { Chart, ChartVue2 };